import { reverse } from 'named-urls'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import type { EmptyStateProps, TableData } from '@fourthwall/components'
import { EmptyState, List, Table, useMediaQueryContext } from '@fourthwall/components'
import { useWebViewBridge } from '@fourthwall/webview-bridge'
import type { LocationState } from '@types'
import { routing } from '@utils/routing'

import type { Promotion } from '../../../../Promotions.types'
import { isShopPromotion } from '../../../../utils/isShopPromotion'
import { PromotionCodeListItem } from '../PromotionCodeListItem/PromotionCodeListItem'
import { TABLE_HEADERS } from './consts'

type PromotionsTableProps = {
  data: TableData<Promotion>[]
  isLoading: boolean
  emptyStateProps: EmptyStateProps
}

const getPromotionLink = (promotion: any, locationState: LocationState) => {
  const promotionId = promotion.id

  if (isShopPromotion(promotion)) {
    return {
      pathname: reverse(routing.promotions.promotionCodes.promotionCode.self, {
        promotionId,
      }),
      search: location.search,
      state: locationState,
    }
  }

  return {
    pathname: reverse(routing.promotions.promotionCodes.membershipsPromotion.self, {
      promotionId,
    }),
    search: location.search,
    state: locationState,
  }
}

export const PromotionCodesData = ({ data, isLoading, emptyStateProps }: PromotionsTableProps) => {
  const media = useMediaQueryContext()
  const location = useLocation()
  const { isWebView } = useWebViewBridge()
  const emptyComponent = <EmptyState {...emptyStateProps} />
  const shouldShowLoading = isWebView ? data.length === 0 : true

  const locationState: LocationState = {
    from: { label: 'Promotion codes', location },
  }

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading && shouldShowLoading}
        getItemLink={(promotion) => getPromotionLink(promotion, locationState)}
        renderItem={(promotion: Promotion) => <PromotionCodeListItem promotion={promotion} />}
        emptyComponent={emptyComponent}
        locationState={locationState}
      />
    )
  }

  return (
    <Table
      data={data}
      headers={TABLE_HEADERS}
      isLoading={isLoading}
      rowComponent={Link}
      emptyComponent={emptyComponent}
      getRowLink={(promotion) => getPromotionLink(promotion, locationState)}
    />
  )
}
